export const TOGGLE_MOBILE_NAV = "TOGGLE_MOBILE_NAV";

export const FETCH_DYNAMIC_FIELDS_REQUEST = 'FETCH_DYNAMIC_FIELDS_REQUEST';
export const FETCH_DYNAMIC_FIELDS_SUCCESS = 'FETCH_DYNAMIC_FIELDS_SUCCESS';
export const FETCH_DYNAMIC_FIELDS_FAILURE = 'FETCH_DYNAMIC_FIELDS_FAILURE';
